import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { Subject } from 'rxjs'
import { finalize, first, takeUntil } from 'rxjs/operators'
import { HubtypeBot } from '../../../models/hubtype-bot'
import * as fromRoot from '../../../reducers'
import { BotService } from '../../../services/hubtype-api/bot.service'

@Component({
  selector: 'app-channels-zendesk',
  templateUrl: './zendesk.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./zendesk.component.scss'],
  standalone: false,
})
export class ZendeskComponent implements OnInit, OnDestroy {
  public bot: HubtypeBot
  private ngUnsubscribe: Subject<void> = new Subject<void>()
  public feedback: string

  zendeskChannel = {
    zendeskUsername: '',
    zendeskDomain: '',
    zendeskToken: '',
  }

  constructor(
    private store: Store<fromRoot.State>,
    private ref: ChangeDetectorRef,
    private botService: BotService,
    private translate: TranslateService
  ) {}

  get title() {
    return this.translate.instant('shared.addIntegration.zendesk.title')
  }

  get step1Title() {
    return this.translate.instant('shared.addIntegration.zendesk.step1Title')
  }

  get registerHint() {
    return this.translate.instant('shared.addIntegration.zendesk.registerHint')
  }

  get step2Title() {
    return this.translate.instant('shared.addIntegration.zendesk.step2Title')
  }

  get emailPlaceholder() {
    return this.translate.instant(
      'shared.addIntegration.zendesk.emailPlaceholder'
    )
  }

  get domainPlaceholder() {
    return this.translate.instant(
      'shared.addIntegration.zendesk.domainPlaceholder'
    )
  }

  get domainHint() {
    return this.translate.instant('shared.addIntegration.zendesk.domainHint')
  }

  get tokenPlaceholder() {
    return this.translate.instant(
      'shared.addIntegration.zendesk.tokenPlaceholder'
    )
  }

  get tokenHint() {
    return this.translate.instant('shared.addIntegration.zendesk.tokenHint')
  }

  get connectButton() {
    return this.translate.instant('shared.addIntegration.zendesk.connect')
  }

  ngOnInit() {
    this.store
      .select(fromRoot.getBot)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(bot => {
        this.ref.markForCheck()
        this.bot = bot
      })
  }

  addZendesk() {
    this.botService
      .addIntegration(this.bot)
      .pipe(
        first(),
        finalize(() => this.ref.markForCheck())
      )
      .subscribe(
        res => {
          this.feedback = this.translate.instant(
            'shared.addIntegration.zendesk.integrated'
          )
          this.bot.zendesk_is_active = true
        },
        err => {
          this.feedback = this.translate.instant(
            'shared.addIntegration.zendesk.integrationError'
          )
          this.bot.zendesk_is_active = false
        }
      )
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
